import React from "react";
import {IconProps} from "../../../../icons/icon-props-interface";

const IconBurger: React.FC<IconProps> = ({color = 'var(--color-primary-2)'}) => {
    return (
        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 1.8125C0 1.01738 0.638393 0.375 1.42857 0.375H18.5714C19.3616 0.375 20 1.01738 20 1.8125C20 2.60762 19.3616 3.25 18.5714 3.25H1.42857C0.638393 3.25 0 2.60762 0 1.8125ZM0 9C0 8.20488 0.638393 7.5625 1.42857 7.5625H18.5714C19.3616 7.5625 20 8.20488 20 9C20 9.79512 19.3616 10.4375 18.5714 10.4375H1.42857C0.638393 10.4375 0 9.79512 0 9ZM20 16.1875C20 16.9826 19.3616 17.625 18.5714 17.625H1.42857C0.638393 17.625 0 16.9826 0 16.1875C0 15.3924 0.638393 14.75 1.42857 14.75H18.5714C19.3616 14.75 20 15.3924 20 16.1875Z"
                fill={color}
            />
        </svg>
    );
}

export default IconBurger;